module.exports = "/dist/128879da78c6c8eb4e2c07fa3732cea7.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-700.eot
// module id = 32
// module chunks = 0